const l=[{label:"And",value:"AND"},{label:"Or",value:"OR"}];export{l as JOIN_OPERATOR_OPTIONS};
